const CommonUIApiUrl = {
    //#region Common
    GetListValue: "api/CommonUI/GetListValue",
    //#endregion

    //#region City
    GetCities: "api/City/GetCities",
    GetCityInfo: "api/City/GetCityInfo",
    GetCityRelatedPackages: "api/City/GetCityRelatedPackages",
    GetDestinationExplore: "api/City/GetDestinationExplore",
    //#endregion

    //#region Common
    UploadImage: "api/Images/UploadImages",
    DeleteImageById: "api/Images/DeleteImagesByReferenceId",
    UpdateImageById: "api/Images/UpdateImagesByReferenceId",
    //#endregion

    //#region Speciality Tours
    GetSpecialityTours: "api/CommonUI/GetSpecialityTours",
    //#endregion

    //#region GetGlobalSearch
    GetGlobalSearch: "api/CommonUI/GetGlobalSearch",
    //#endregion
}
export default CommonUIApiUrl;